var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { css } from 'styled-components';
import { SCHEME_MODIFIERS } from '../../types/Designs.types';
export var getSchemaModifierStyles = function (modifier) {
    return function (props) {
        if (props === void 0) { props = {}; }
        var schema = props.schema;
        var schemaModifierStyles = schema === null || schema === void 0 ? void 0 : schema[modifier];
        if (!schemaModifierStyles)
            return '';
        if (typeof schemaModifierStyles !== 'object')
            return schemaModifierStyles;
        var modCustomCss = schemaModifierStyles.css, modifierCssObject = __rest(schemaModifierStyles, ["css"]);
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n      ", "\n    "], ["\n      ", "\n      ", "\n    "])), css(modifierCssObject), modCustomCss);
    };
};
export var getDependencySchemaModifierStyles = function (attr, modifier) {
    return function (props) {
        return getSchemaModifierStyles(modifier)({ schema: props[attr] });
    };
};
export var errorMixin = function (_a) {
    var error = _a.error;
    return error && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), getSchemaModifierStyles(SCHEME_MODIFIERS.error));
};
export var activeMixin = function (_a) {
    var active = _a.active;
    return active && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), getSchemaModifierStyles(SCHEME_MODIFIERS.active));
};
export var defaultMixin = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.default));
export var hoverMixin = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &:hover {\n    ", "\n  }\n"], ["\n  &:hover {\n    ", "\n  }\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.hover));
export var disabledMixin = function (_a) {
    var disabled = _a.disabled;
    return disabled && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), getSchemaModifierStyles(SCHEME_MODIFIERS.disabled));
};
export var focusMixin = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &:focus {\n    ", "\n  }\n"], ["\n  &:focus {\n    ", "\n  }\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.focus));
export var placeholderMixin = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  &::placeholder {\n    ", "\n  }\n"], ["\n  &::placeholder {\n    ", "\n  }\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.placeholder));
export var skeletonMixin = function (_a) {
    var isLoading = _a.isLoading, skeleton = _a.skeleton;
    return (isLoading || skeleton) && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), getSchemaModifierStyles(SCHEME_MODIFIERS.skeleton));
};
export var readonlyMixin = css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  &:read-only {\n    ", "\n  }\n"], ["\n  &:read-only {\n    ", "\n  }\n"])), getSchemaModifierStyles(SCHEME_MODIFIERS.readonly));
export var designSchema = css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), defaultMixin, hoverMixin, disabledMixin, focusMixin, activeMixin, errorMixin, placeholderMixin, readonlyMixin, skeletonMixin);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
